module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_4-8378d3c884026c1a3f8dacabdfb4fddd.jpg";